import dynamic from 'next/dynamic'

import type { IAccountDevToolProps } from './AccountDevTool'


import { useState, useEffect } from 'react';
const AccountDevTool = dynamic(() => import('./AccountDevTool'), {
  ssr: false,
})

function DynamicAccountDevTool(props: IAccountDevToolProps) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_APP_ENV !== 'production') {
      setIsMounted(true)
    }
    return () => setIsMounted(false)
  }, [])

  if (!isMounted) {
    return null
  }

  return <AccountDevTool {...props} />
}

export default DynamicAccountDevTool
